import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { AtividadeVisualizacaoComponent } from './atividade-visualizacao.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        AtividadeVisualizacaoComponent
    ],
    exports: [
        AtividadeVisualizacaoComponent
    ]
})
export class AtividadeVisualizacaoModule { }
